/** #668 — the Help routes (mounted by app/routes.tsx under the shell). */
import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';
import { RouteFallback } from '@/app/shell/RouteFallback';

const AppStandardPage = lazy(() => import('./AppStandardPage'));

export const HELP_ROUTES: RouteObject[] = [
  {
    path: 'help/app-standard',
    element: (
      <Suspense fallback={<RouteFallback />}>
        <AppStandardPage />
      </Suspense>
    ),
  },
];
